import React from 'react';
import './FooterStyle.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="ja-footer">
      <div className="ja-footer-container">
        <p className="ja-footer-copy">
          &copy; {currentYear} MBSoftwareSolutions. Alle Rechte vorbehalten.
        </p>
        <nav className="ja-footer-nav">
          <a
            href="https://mbsoftwaresolutions.de/produkte/rescueplattform/junioralarm/agb"
            target="_blank"
            rel="noopener noreferrer"
          >
            AGB
          </a>
          <span className="ja-footer-divider">•</span>
          <a
            href="https://mbsoftwaresolutions.de/produkte/rescueplattform/junioralarm/datenschutzerklaerung"
            target="_blank"
            rel="noopener noreferrer"
          >
            Datenschutz
          </a>
          <span className="ja-footer-divider">•</span>
          <a
            href="https://mbsoftwaresolutions.de/produkte/rescueplattform/junioralarm/nutzungsbedingungen"
            target="_blank"
            rel="noopener noreferrer"
          >
            Nutzungsbedingungen
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;